import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';
/**
 * Дробные индексы порядка.
 *
 * Целочисленный `order` из прототипа при конкурентной перестановке даёт кашу:
 * две перестановки на разных устройствах перенумеруют соседей и затрут друг
 * друга. Дробный индекс — строка, которую всегда можно вставить между двумя
 * соседями, не трогая их: перестановка меняет ровно одну запись (раздел 3.3).
 */
/** Ключ первой записи в пустом списке. */
export const FIRST_ORDER_KEY = generateKeyBetween(null, null);
/** Ключ строго между `a` и `b`; `null` — край списка. */
export function orderKeyBetween(a, b) {
    return generateKeyBetween(a, b);
}
/** Сразу несколько ключей между соседями — для массовой вставки. */
export function orderKeysBetween(a, b, count) {
    return generateNKeysBetween(a, b, count);
}
/**
 * Худший случай дробного индекса — два одинаковых ключа у конкурентных вставок.
 * Разводится тай-брейком по id, чтобы порядок оставался одинаковым везде.
 */
export function compareOrder(a, b) {
    if (a.order_key !== b.order_key)
        return a.order_key < b.order_key ? -1 : 1;
    if (a.id === b.id)
        return 0;
    return a.id < b.id ? -1 : 1;
}
//# sourceMappingURL=order.js.map